import { useState, useEffect } from 'react';
import { getTopSellingProductsThisMonth } from '../services/productService';
import { Product } from '../types';

interface UseTopProductsResult {
  data: Product[];
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export const useTopProducts = (limitCount: number = 5): UseTopProductsResult => {
  const [data, setData] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const topProducts = await getTopSellingProductsThisMonth(limitCount);
      setData(topProducts);
    } catch (err) {
      console.error('Error fetching top products:', err);
      setError('Failed to load top products');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    await fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [limitCount]);

  return {
    data,
    loading,
    error,
    refresh
  };
}; 